import $ from "jquery/dist/jquery";

$(() => {
    function variantSelected(evt) {
        let s = $(evt.target);
        let targetSel = s.attr('data-variant-target');
        let url = s.val();
        if ($(targetSel)) {
            s.addClass('loading');
            s.prop('disabled', true);
            loadVariant(url, targetSel, true);
        } else {
            window.location = url;
        }
    }

    function loadVariant(url, targetSel, saveState) {
        let t = $(targetSel);
        $.ajax({
            method: 'get',
            url: url,
            data: {
                'detail': 1
            }
        }).done((d) => {
            t.html(d);
            if (saveState) {
                history.pushState({
                    'variantUrl': url,
                    'variantSelector': targetSel,
                }, null, url);
            }
        }).fail(() => {
            window.location = url;
        });
    }

    function subVariantSelected(evt) {
        let sw = $(evt.target).closest('.variant-selector-multi');
        let targetSel = sw.attr('data-variant-target');

        let dsturl = filterSubVariants(sw);
        if (dsturl) {
            loadVariant(dsturl, targetSel, true);
        }
    }

    function filterSubVariants(els, initial = false) {
        let returl = null;

        $(els).each(function () {
            let sw = $(this);
            let choices = JSON.parse(sw.attr('data-variant-choices'));

            sw.find('.variant-selector-part').each(function () {
                // prepare filter matrix based on parents
                let filter_data = {};
                let e = this;
                let disable_all = false;
                while (e) {
                    let spq = $(e);
                    let psel = spq.attr('data-variant-parent');
                    if (psel) {
                        let p = $(psel);
                        let pval = p.val();
                        if (pval == '_EMPTY_' || pval === null) {
                            disable_all = true;
                            e = null;
                        }
                        filter_data[p.attr('name')] = pval;
                    }
                    e = null;
                }

                // find out available choices
                const available_choices = choices.filter((obj) => {
                    let valid = true;
                    for (const [k, v] of Object.entries(filter_data)) {
                        if (obj[k] != v) {
                            valid = false;
                            break;
                        }
                    }
                    return valid;
                });

                // find out which slugs are available
                let enabled_slugs = [];
                if (disable_all) {
                    enabled_slugs = [];
                } else {
                    const myname = $(this).attr('name');
                    enabled_slugs = available_choices.map(x => x[myname]);
                    enabled_slugs = enabled_slugs.unique();
                }

                // enable / disable them
                $(this).find('option').each(function () {
                    if ($(this).val() in enabled_slugs) {
                        $(this).prop('disabled', false);
                    } else {
                        $(this).prop('disabled', true);
                    }
                });

                // unselect disabled options
                if ($(this).find('option:disabled:selected').length) {
                    $(this).val('_EMPTY_');
                }
            });

            // check that filters are valid for exacly one item
            let allchecked = true;
            let final_filter_data = {};
            sw.find('.variant-selector-part').each(function () {
                let val = $(this).val();
                if (val == '_EMPTY_' || val === null) {
                    allchecked = false;
                }
                final_filter_data[$(this).attr('name')] = val;
            });

            let final_choices = choices.filter((obj) => {
                let valid = true;
                for (const [k, v] of Object.entries(final_filter_data)) {
                    if (obj[k] != v) {
                        valid = false;
                        break;
                    }
                }
                return valid;
            });

            if (final_choices.length <= 0 && allchecked) {
                sw.find('.variant-selector-part').val('_EMPTY_');
            }

            returl = null;

            if (final_choices.length == 1) {
                returl = final_choices[0].url;
            }
        });

        if (initial) {
            $(els).each(function () {
                $(this).find('.variant-selector-part').each(function () {
                    const spq = $(this);
                    const val = spq.val();
                    if ((val == '_EMPTY_' || val === null) && (spq.find('option:not(:disabled)').length) == 1) {
                        spq.val(spq.find('option:not(:disabled)').val());
                        subVariantSelected({ 'target': spq[0] });
                    }
                });
            });
        }
        return returl;
    }

    $(window).on('popstate', function (e) {
        const oe = e.originalEvent;
        if (oe.state) {
            if (oe.state.variantUrl && oe.state.variantSelector) {
                loadVariant(oe.state.variantUrl, $(oe.state.variantSelector), false);
            }
        }
    });

    $(() => {
        $(document).on('change', '.variant-selector', variantSelected);
        $('.variant-selector').prop('disabled', false);

        $(document).on('change', '.variant-selector-multi .variant-selector-part', subVariantSelected);
        filterSubVariants($('.variant-selector-multi'), true);
    });
});
